module.exports = __webpack_public_path__ + "media/images/arrow-down-ce5b9c3823bbfcc87f7f3f17dccd4da7.svg";